/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CardC from "../../../components/CustomCard/CardC";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Loader, toaster } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import Form from "./Form";
import { Button } from "react-bootstrap";
import createURL from "../../../libs/peticiones/url";
import { Modulo } from "../../../types/admin-usuarios/Modulo";
import Treetable from "../../../components/treeTable/TreeTable";
import { Sistema } from "../../../types/admin-usuarios/Sistema";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { useStore } from "../../../context/AppContext";

export default function Modulos() {
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<Modulo|undefined>();
    const { state } = useStore();
    const [data, setData] = useState<Modulo[]>([]);

    useEffect(()=>{
        if(open===false)getData(); 
    },[open])

    async function getData(){
        const url = createURL("/modulos", [
            {name: "populate", value: "system"},
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        if(res.data && res.data.length > 0){
            recursiveMap(res.data);
        }
        setData(res.data);
        setRefresh(true);
    }

    function recursiveMap(modules: Array<Modulo>, parent?: Modulo){
        modules.forEach((mod: any)=> {
            if(parent) mod.parent = parent;
            if(mod.children){
                const cpPad = {...mod}
                delete cpPad.children;
                recursiveMap(mod.children, cpPad);
            }
        });
    }
    
    /* TABLA */
    const columns = [
        {data: "name"},
        {data: "route"},
        {data: "parent", render: (p: Modulo|undefined)=> <p>{p && p.name}</p>},
        {data: "system", render: (s: Sistema|undefined)=> <p>{s ? s.name : "N/A"}</p>, orderValue: "system.name"},
        {
            data: null, 
            render: (row: Modulo)=>(
                <div className="d-flex justify-content-evenly">
                   {checkPermission(state, "update") &&  <FontAwesomeIcon icon={faPencil} className="text-warning cursor-pointer" onClick={()=>openToEdit(row)} />}
                   {checkPermission(state, "delete") && <FontAwesomeIcon 
                        icon={faTrashCan} 
                        className="text-danger cursor-pointer" 
                        onClick={
                            ()=>swalAction(
                                deleteRow, 
                                "Eliminar Módulo", 
                                `¿Desea eliminar el módulo ${row.name}?`, 
                                "question", 
                                row._id, 
                                "Eliminar"
                            )
                        } 
                    />}
                </div>
            )
        }
    ];

    const columnDefs = [
        {orderable: false, targets: [4]},
        {className: "text-center", targets: [0,1,2,3]}
    ]

    async function deleteRow(id: number){
        setLoading(true);
        const res = await peticionBack({}, `/modulos/${id}`, "DELETE", true, toaster);
        if(res) getData();
        setLoading(false);
    }

    function openToEdit(row: Modulo){ setSelected(row); }

    useEffect(()=>{
        if(selected) setOpen(true);
    }, [selected]);

    useEffect(()=>{
        if(!open){
            if(selected) setSelected(undefined);
            // setRefresh(true);
        }
    }, [open]);
    
    return (
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Módulos {open && (selected? "- Editar" : "- Agregar")}</h4>
                {!open && checkPermission(state, "create") && <Button onClick={()=>setOpen(true)} className="my-1 my-md-0">Agregar</Button>}
            </div>
            {
                open ? 
                    <Form setOpen={setOpen} selected={selected} /> : checkPermission(state, "read") &&
                    <Treetable
                        columns={columns}
                        headers={["Nombre", "Ruta", "M. Padre", "Sistema", "Acciones"]}
                        columnDefs={columnDefs}
                        // petition={getData}
                        control="front"
                        data={data}
                        stateRefresh={[refresh, setRefresh]}
                        className="p-0"
                    />
            }
            { loading && <Loader backdrop vertical style={{zIndex: 5}} /> }
        </CardC>
    );
}
